import React from 'react';
import PropTypes from 'prop-types';
import Navigation from '../../Navigation/NavigationContainer';
import Validation from '../../Validation/ValidationContainer';
import AdvWorkflowStep from '../../AdvWorkflowStep/AdvWorkflowStepContainer';
import {
  BACKEND_EDUCATION_LIST_KEY,
  BACKEND_EDUCATION_GOAL_API,
} from '../ChildrenInfoWorkflowConstants';
import {
  isNonEmptyString,
  isNumeric,
  createCustomPropType,
} from '../../../../js/app/react/validators';
import { isSpecificSchoolValidator } from '../ChildrenInfoWorkflowValidator';
import workflowAnalyticsEvents from '../../AnalyticsWorkflow/AnalyticsWorkflow';
import AdvForm from '../../../CommonComponents/AdvForm';

const IN_STATE = 0;
const OUT_OF_STATE = 1;

const tuitionTypeOptions = [
  { label: 'In-State', value: IN_STATE },
  { label: 'Out-Of-State', value: OUT_OF_STATE },
];

const TuitionTypeView = ({
  workflowId,
  branch,
  clientId,
  store,
  isEditingGoal,
  educationGoal,
  onPostProcess,
}) => {
  const inStateTotal =
    educationGoal.SpecificCollegeInformation &&
    educationGoal.SpecificCollegeInformation.InStateTotal;
  const outOfStateTotal =
    educationGoal.SpecificCollegeInformation &&
    educationGoal.SpecificCollegeInformation.OutOfStateTotal;

  return (
    <AdvWorkflowStep
      branch={branch}
      workflowId={workflowId}
      id="SpecificCollegeIsInState"
      canSkip={
        !(
          educationGoal.IsSpecificCollege &&
          educationGoal.SpecificCollegeInformation &&
          educationGoal.SpecificCollegeIsPublic
        )
      }
    >
      <Validation
        workflowId={workflowId}
        validationId={`${BACKEND_EDUCATION_LIST_KEY}.SpecificCollegeIsInState`}
      />

      <h2>What is the tuition type?</h2>

      <AdvForm>
        <ul className="horizontal school-list">
          {tuitionTypeOptions.map(({ value, label }) => (
            <li key={value} className="school-item">
              <div
                onKeyDown={() => {}}
                role="button"
                tabIndex="-1"
                onClick={() =>
                  store(
                    value === IN_STATE,
                    value === IN_STATE ? inStateTotal : outOfStateTotal,
                    workflowId,
                    clientId,
                  )
                }
              >
                <div
                  className={`school-item__button-radio-empty${
                    (educationGoal.SpecificCollegeIsInState && value === IN_STATE) ||
                    (!educationGoal.SpecificCollegeIsInState && value === OUT_OF_STATE)
                      ? ' selected'
                      : ''
                  }`}
                />
                <button type="button" className="school-item__button">
                  {label}
                </button>
              </div>
            </li>
          ))}
        </ul>
      </AdvForm>

      <Navigation
        nextIterators={[]}
        dirtyGraphNodes={[]}
        validator={isSpecificSchoolValidator(educationGoal.SpecificCollegeIsInState)}
        validationId={`${BACKEND_EDUCATION_LIST_KEY}.SpecificCollegeIsInState`}
        workflowId={workflowId}
        backendKey={BACKEND_EDUCATION_GOAL_API}
        doNotSave={!isEditingGoal}
        onPostProcess={data => onPostProcess(data, educationGoal)}
        validatedOnClick={() =>
          workflowAnalyticsEvents(workflowId, 'education_tuition_type_selected')
        }
      />
    </AdvWorkflowStep>
  );
};

TuitionTypeView.propTypes = {
  branch: PropTypes.arrayOf(PropTypes.number.isRequired).isRequired,
  workflowId: createCustomPropType(isNonEmptyString).isRequired,
  clientId: createCustomPropType(isNumeric).isRequired,
  store: PropTypes.func.isRequired,
  isEditingGoal: PropTypes.bool.isRequired,
  educationGoal: PropTypes.shape({
    SpecificCollegeIsInState: PropTypes.bool,
  }).isRequired,
  onPostProcess: PropTypes.func.isRequired,
};

export default TuitionTypeView;
